import { useMutation } from "@apollo/client";
import { ADD_DOCS_TO_REFERRAL } from "../../mutations/referrals";
import {
  removeDocumentsFromList,
  getClientDocs,
  addDocsToReferralSuccess,
  newDocListShouldRefresh,
} from "../../state/ducks/docserver";
import { addDocuments } from "../../state/ducks/form";
import { enqueueSnackbar } from "../../state/ducks/notifiers";
import { hydrateDialogReferral } from "../../state/ducks/editDialog";
import { useDispatch } from "react-redux";
import useFetchReferral from "../useFetchReferral";

const useAddDocumentsToReferral = () => {
  const dispatch = useDispatch();
  const { handleFetchReferral } = useFetchReferral();

  const [addDocumentsToReferral] = useMutation(ADD_DOCS_TO_REFERRAL, {
    onCompleted: () => {
      dispatch(
        enqueueSnackbar({
          message: `Referral's documents have been updated!`,
          options: {
            variant: "success",
          },
        })
      );
    },
    onError: () => {
      dispatch(
        enqueueSnackbar({
          message: `Failed to add document to referral`,
          options: { variant: "error" },
        })
      );
    },
  });

  const addDocsToReferral = async (
    data,
    refetchQueries = [],
    referral = null,
    fromDialog = false,
    signingReferral = false,
    refreshNewDocList = false
  ) => {
    const { variables } = data;
    try {
      await addDocumentsToReferral({
        refetchQueries,
        variables,
      });
      const documentIds = variables.documentIds.map((uuid) => ({ uuid }));
      dispatch(removeDocumentsFromList(documentIds));
      dispatch(getClientDocs());
      dispatch(addDocuments(documentIds, variables.processInstanceId));

      if (referral) {
        const refreshedReferral = await handleFetchReferral(referral.id, {
          inspectReferral: true,
          cardDetail: fromDialog ? false : !signingReferral,
          fetchPolicy: "network-only",
        });
        if (refreshedReferral) {
          dispatch(hydrateDialogReferral(refreshedReferral));
        }
      }
      dispatch(addDocsToReferralSuccess());
      if (refreshNewDocList) {
        dispatch(newDocListShouldRefresh(refreshNewDocList));
      }
    } catch (error) {
      console.error("Error adding documents to referral:", error);
      dispatch(
        enqueueSnackbar({
          message: `Failed to add document to referral`,
          options: { variant: "error" },
        })
      );
    }
  };

  return {
    addDocsToReferral,
  };
};

export default useAddDocumentsToReferral;
